import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { ColumnType } from '@shared/components/beyond-table/model/column.model';
import { CustomFieldModel } from '@base/modules/rest/custom-field/model/custom-field.model';
import { CustomFieldTypesEnum } from '@base/modules/rest/custom-field/enums/custom-field-types.enum';
import { CellPreparedEvent } from 'devextreme/ui/data_grid';
import { NEW__ } from '@base/utils/table-data.util';
import { ItemsTableComponent } from '../items-table.component';

interface CellData {
  column: ColumnType;
  value: any;
  text?: string;
}

export class ItemsTableValidation {

  constructor(private itemsTable: ItemsTableComponent) {
  }

  customValidation(): {rowIndex: number; dataField: string}[] {
    const allRows: DxDataGridTypes.Row[] = this.itemsTable.dataGrid.instance.getVisibleRows()
      .filter(row => row.rowType === 'data');
    const invalidCells: {rowIndex: number; dataField: string}[] = [];

    allRows
      .filter( row => !row.data[NEW__])
      .forEach((row: any) => {
      row.cells.forEach(cell => {
        const isFieldValid = this.isCellValid(cell);
        if (!isFieldValid) {
          invalidCells.push({ rowIndex: row.rowIndex, dataField: cell.column.dataField });
        }
      });
    });

    return invalidCells;
  }

  isCellValid(cell: CellData): boolean | undefined {
    let isValid = true;
    if (!!cell.column.dataField) {
      const field: CustomFieldModel = this.itemsTable.findFieldByDbName(cell.column.dataField);
      isValid = this.cellValidateByFieldType(field, cell);
    }
    return isValid;
  }

  validateSingleCell(e: CellPreparedEvent): boolean {
    const cell: CellData = {
      column: e.column as ColumnType,
      value: e.value,
    };
    return this.isCellValid(cell);
  }

  cellValidateByFieldType(field: CustomFieldModel, cell: CellData): boolean {
    if (!field?.type) {
      return true;
    }
    switch (field.type) {
      case CustomFieldTypesEnum.DATE:
      case CustomFieldTypesEnum.DATE_TIME:
      case CustomFieldTypesEnum.DATE_PERIOD:
      case CustomFieldTypesEnum.DATE_TIME_PERIOD:
      case CustomFieldTypesEnum.CHECKBOX:
      case CustomFieldTypesEnum.SWITCHER:
      case CustomFieldTypesEnum.NUMBER:
      case CustomFieldTypesEnum.DECIMAL_NUMBER:
      case CustomFieldTypesEnum.PERCENT:
      case CustomFieldTypesEnum.SELECT:
      case CustomFieldTypesEnum.RADIO_BUTTON:
      case CustomFieldTypesEnum.MULTISELECT:
      case CustomFieldTypesEnum.NUMERATION:
        return mandatoryFieldValidation(field, cell);
      case CustomFieldTypesEnum.LOOKUP:
      case CustomFieldTypesEnum.TEXT:
      case CustomFieldTypesEnum.TEXTAREA:
      case CustomFieldTypesEnum.EMAIL:
      case CustomFieldTypesEnum.PHONE:
        return textFiledValidation(field, cell);
    }
    return true;
  }
}

function mandatoryFieldValidation(field: CustomFieldModel, cell: CellData): boolean {
  if (field.readOnly) {
    return true;
  }
  if (field.mandatory && !cell.value) {
    return false;
  }
  return  true;
}

function textFiledValidation(field: CustomFieldModel, cell: CellData): boolean {
  if (field.readOnly) {
    return true;
  }
  if (field.mandatory && !cell.value) {
    return false;
  }
  if (!!field.regex && !new RegExp(field.regex).test(cell.value)) {
    return false;
  }
  if (!!field.maxLength && cell.value?.length > field.maxLength) {
    return false;
  }
  return true;
}
